<template>
  <div>
    <validation-observer ref="refFormObserver">
      <b-form>
        <b-row>
          <b-col cols="12" lg="6">
            <validation-provider
              #default="validationContext"
              name="tenant"
              rules="required"
            >
              <b-form-group
                label="Tenant"
                label-for="id_tenant"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  data-cy="tenant-select"
                  :value="itemData.id_tenant"
                  @input="emitUpdate('id_tenant', $event)"
                  :dir="direction"
                  :options="tenantOptions"
                  :clearable="false"
                  :reduce="(val) => val.value"
                  input-id="id_tenant"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" lg="6">
            <validation-provider
              #default="validationContext"
              name="name"
              rules="required"
            >
              <b-form-group
                :label="$t('proxy_rtsp_server.name')"
                label-for="name"
                :state="getValidationState(validationContext)"
              >
                <b-form-input
                  data-cy="name-input"
                  :value="itemData.name"
                  @input="emitUpdate('name', $event)"
                  id="name"
                  type="text"
                  trim
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6">
            <validation-provider
              #default="validationContext"
              name="api_host"
              rules="required"
            >
              <b-form-group
                :label="$t('proxy_rtsp_server.api_host')"
                label-for="api_host"
                :state="getValidationState(validationContext)"
              >
                <b-form-input
                  data-cy="api-host-input"
                  :value="itemData.api_host"
                  @input="emitUpdate('api_host', $event)"
                  id="api_host"
                  type="text"
                  trim
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" lg="6">
            <validation-provider
              #default="validationContext"
              name="rtsp_host"
              rules="required"
            >
              <b-form-group
                :label="$t('proxy_rtsp_server.rtsp_host')"
                label-for="rtsp_host"
                :state="getValidationState(validationContext)"
              >
                <b-form-input
                  data-cy="rtsp-host-input"
                  :value="itemData.rtsp_host"
                  @input="emitUpdate('rtsp_host', $event)"
                  id="rtsp_host"
                  type="text"
                  trim
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <!-- Continuar con el mismo patrón para los otros campos -->
        <b-row>
          <b-col cold="12" lg="6">
            <validation-provider
              #default="validationContext"
              name="playback_host"
              rules="required"
            >
              <b-form-group
                :label="$t('proxy_rtsp_server.playback_host')"
                label-for="playback_host"
                :state="getValidationState(validationContext)"
              >
                <b-form-input
                  data-cy="playback-host-input"
                  :value="itemData.playback_host"
                  @input="emitUpdate('playback_host', $event)"
                  id="playback_host"
                  type="text"
                  trim
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" lg="6">
            <validation-provider
              #default="validationContext"
              name="hls_host"
              rules="required"
            >
              <b-form-group
                :label="$t('proxy_rtsp_server.hls_host')"
                label-for="hls_host"
                :state="getValidationState(validationContext)"
              >
                <b-form-input
                  data-cy="hls-host-input"
                  :value="itemData.hls_host"
                  @input="emitUpdate('hls_host', $event)"
                  id="hls_host"
                  type="text"
                  trim
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6">
            <validation-provider
              #default="validationContext"
              name="webrtc_host"
              rules="required"
            >
              <b-form-group
                :label="$t('proxy_rtsp_server.webrtc_host')"
                label-for="webrtc_host"
                :state="getValidationState(validationContext)"
              >
                <b-form-input
                  data-cy="webrtc-host-input"
                  :value="itemData.webrtc_host"
                  @input="emitUpdate('webrtc_host', $event)"
                  id="webrtc_host"
                  type="text"
                  trim
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormCheckbox,
} from "bootstrap-vue";
import { ref, onMounted, computed, watch } from "@vue/composition-api";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import formValidation from "@core/comp-functions/forms/form-validation";
import { useToast } from "vue-toastification/composition";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import vSelect from "vue-select";
import store from "@/store";

export default {
  name: "GeneralStep",
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    BFormCheckbox,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    propItemData: {
      type: Object,
      required: true,
    },
    tenantOptions: {
      type: Array,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18nUtils();
    const toast = useToast();
    const { refFormObserver, getValidationState } = formValidation();
    const direction = computed(() => {
      return store.state.appConfig.isRTL ? "rtl" : "ltr";
    });

    const itemData = ref(JSON.parse(JSON.stringify(props.propItemData)));

    const validateStep = async () => {
      if (!refFormObserver.value) {
        console.warn("Validation observer is not initialized");
        return false;
      }
      const validation = await refFormObserver.value.validate();
      return validation;
    };

    watch(
      () => props.propItemData,
      (newValue) => {
        if (newValue) {
          itemData.value = JSON.parse(JSON.stringify(newValue));
        }
      },
      { deep: true }
    );

    const emitUpdate = (key, value) => {
      emit("update:itemData", { [key]: value });
    };

    return {
      t,
      toast,
      refFormObserver,
      getValidationState,
      itemData,
      direction,
      validateStep,
      emitUpdate,
    };
  },
};
</script>
